import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {
  dateFormat,
  splitMissionName,
} from "../../../services/Utils/functionService";
import ProgressBar from "../../../components/Cac/Partner/Utils/MonitoringElements/ProgressBar";
import StatusRequest from "../../../components/Cac/Customer/Request/StatusRequest";
import CustomerRequestTable from "../../../components/Cac/Customer/Request/CustomerRequestTable";
import { useCustomerRequestsStore } from "../../../stores/Cac/Customer/customerRequests";
import { usePartnerRequestDetailsStore } from "../../../stores/Cac/Partner/partnerRequestDetails";
import RequestDocuments from "../../../components/Cac/Customer/Request/RequestDocuments";
import { usePartnerRequestsStore2 } from "../../../stores/Cac/Partner/partnerRequests";
import {
  getDocRequests,
  getMissionDataByCustomer,
} from "../../../services/Api/customerService";
import SideBar from "../../../components/Layout/SideBar";
import Header from "../../../components/Layout/Header";
import Footer from "../../../components/Layout/Footer";
import { showToastError } from "../../../services/Toasts/toasts";

const CustomerRequests = () => {
  const { t } = useTranslation();
  // Store
  const {
    dataMission,
    setDataMission,
    requests,
    setRequests,
    openDetailsCustomer,
    setRequestIdCustomer,
  } = useCustomerRequestsStore();
  const { requestRefused } = usePartnerRequestDetailsStore();
  const { updateRequest } = usePartnerRequestsStore2();

  // Hooks
  const navigate = useNavigate();
  const { idCustomer, idMission } = useParams();

  useEffect(() => {
    if (openDetailsCustomer === undefined) setRequestIdCustomer(0);
  }, [openDetailsCustomer]);

  useEffect(() => {
    getMissionDataByCustomer(Number(idCustomer), Number(idMission))
      .then((data) => setDataMission(data))
      .catch(() => showToastError(t("common.error")));
    if (idCustomer && idMission) {
      getDocRequests(parseInt(idCustomer), parseInt(idMission))
        .then((data) => setRequests(data))
        .catch(() => showToastError(t("common.error")));
      }
  }, [openDetailsCustomer, requestRefused, updateRequest]);

  return (
    <div className="flex h-dvh w-full flex-col overflow-hidden bg-gradient-to-br from-slate-50 to-blue-50">
      <Header />
      <div className="flex min-h-0 flex-1 overflow-hidden">
        <SideBar />
        <RequestDocuments />
        <main className="flex min-h-0 flex-1 scroll-pb-24 flex-col overflow-y-auto pb-24 pt-3 sm:scroll-pb-20 sm:pl-14 md:pb-20">
          <div className="mx-auto flex min-h-0 w-full max-w-7xl flex-1 flex-col gap-3 px-3 lg:px-4 2xl:max-w-[2400px]">
          
          {/* Header Section avec design moderne */}
          <section className="w-full flex-shrink-0 rounded-2xl border border-gray-100 bg-white p-4 shadow-md sm:p-5">
            <div className="flex items-start justify-between gap-4 lg:items-center">
              <div className="flex min-w-0 items-center gap-3 sm:gap-4">
                <div className="hidden md:flex flex-shrink-0 rounded-xl bg-blue-100 p-2.5 sm:p-3">
                  <svg className="h-5 w-5 text-blue-600 sm:h-6 sm:w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <h1 className="font-K2D text-lg font-bold text-gray-700 sm:text-xl">
                    {t("customerRequests.mission")} : <span className="text-blue-600">{splitMissionName(dataMission?.name)}</span>
                  </h1>
                  <p className="mt-1 text-sm text-gray-600 sm:text-base">
                    {t("customerRequests.dueDate")} : {dateFormat(dataMission?.dueDate)}
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Navigation et contrôles */}
          <section className="w-full flex-shrink-0 rounded-2xl border border-gray-100 bg-white p-3 shadow-md">
            <div className="flex flex-col items-start justify-between gap-4 lg:flex-row lg:items-center">
              <div className="w-full lg:max-w-lg">
                {requests.length > 0 && (
                  <div className="flex w-full flex-col gap-2 sm:flex-row sm:items-center">
                    <span className="flex-shrink-0 text-sm text-gray-600">{t("customerRequests.progress")}</span>
                    <ProgressBar />
                  </div>
                )}
                 
              </div>
              
              <div className="w-full lg:w-auto">
                <StatusRequest />
              </div>
            </div>
          </section>

          {/* Table des requêtes avec design moderne */}
          <section className="min-h-[24rem] w-full flex-1 overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-md">
            <CustomerRequestTable />
          </section>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default CustomerRequests;
